module.exports = __webpack_public_path__ + "img/infibo-how-to-subscribe-en-1.240fd148.png";